// extracted by mini-css-extract-plugin
export var content = "_q4-1";
export var fullScreen = "_q4-0";